import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { IsAllowedService } from '@k2/common/permissions/IsAllowedService';

@Pipe({
    name: 'isAllowed',
    standalone: false
})
export class IsAllowedPipe implements PipeTransform {
  constructor(private isAllowedService: IsAllowedService) {}

  transform(expression: string): Observable<boolean> {
    return this.isAllowedService.isAllowed(expression);
  }
}
